export function createSafeWorker(url: URL): Worker | null {
  if (typeof window === "undefined" || typeof window.Worker === "undefined") {
    return null;
  }
  try {
    return new Worker(url, { type: "module" });
  } catch {
    try {
      // fallback classic worker
      return new Worker(url as unknown as string);
    } catch {
      return null;
    }
  }
}
